import { action, observable } from 'mobx';

export default class NotificationsStore {
  @observable toastNotifications: Map<string, ToastOptions> = new Map();
  @observable notices: Map<string, BasicAlert> = new Map();
  @observable sideBarNotifications: Map<string, BasicAlert> = new Map();
  @observable importantAlerts: Map<string, BasicAlert> = new Map();
  @observable alertWithOverlay = new Map<string, Omit<BasicAlert, 'type'>>();
  @observable notifications = <{ [K in AlertStatus]: AlertsUnion[] }>{
    read: [],
    unread: [],
  };

  @action pushToast = (
    key: string,
    options: ToastOptions,
  ) => {
    this.toastNotifications.set(key, options);
  };

  @action deleteToast = (key: string) => {
    this.toastNotifications.delete(key);
  };

  @action setNotifications = (
    key: AlertStatus,
    notifications: AlertsUnion[],
  ) => {
    this.notifications[key] = notifications;
  };

  @action pushAlertByType = (
    type: BasicAlertType,
    key: string,
    options: BasicAlert,
  ) => {
    if (type === 'warning') {
      this.importantAlerts.set(key, options);
    } else {
      this.notices.set(key, options);
    }
  };

  @action deleteAlertByType = (type: BasicAlertType, key: string) => {
    if (type === 'warning') {
      this.importantAlerts.delete(key);
    } else {
      this.notices.delete(key);
    }
  };
}
